import React from 'react'

function ButtonActions() {
    return (
        <div>
            Aqui los Botones
        </div>
    )
}

export default ButtonActions